export default "__VITE_ASSET__DJ44TPuI__"